"use client";

import { useEffect } from "react";
import { log } from "@/lib/logger";
import { reportClientError } from "@/lib/observability/report-client-error";
import {
  isStaleDeploymentError,
  reloadOnceForStaleDeployment,
} from "@/lib/observability/stale-deployment";

/**
 * Error boundary racine : attrape les erreurs survenant dans le root layout
 * lui-même (ex. providers globaux, CookieConsent). Remplace tout le document,
 * d'où les styles inline (globals.css n'est plus garanti chargé ici).
 * Trace l'erreur réelle pour diagnostiquer les crashs intermittents en prod.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    log.error("Erreur de rendu (global)", {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
    });
    reportClientError(error, "global");
    // Onglet ouvert avant un déploiement : le bundle référence une Server
    // Action disparue. Un rechargement récupère la version à jour et évite
    // d'afficher un écran d'erreur pour un simple décalage de version.
    if (isStaleDeploymentError(error)) reloadOnceForStaleDeployment();
  }, [error]);

  return (
    <html lang="fr">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "64px 24px",
          textAlign: "center",
          background: "#FAFAF7",
          color: "#1A1A1A",
          fontFamily:
            "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        }}
      >
        <div style={{ width: "100%", maxWidth: 420 }}>
          <h1
            style={{
              margin: "0 0 10px",
              fontSize: 30,
              fontWeight: 400,
              lineHeight: 1.1,
              fontFamily: "Cormorant, Georgia, serif",
            }}
          >
            Une erreur est survenue
          </h1>
          <p
            style={{
              margin: "0 0 32px",
              fontSize: 14,
              lineHeight: 1.6,
              color: "#5A5A55",
            }}
          >
            Quelque chose n&apos;a pas fonctionné de notre côté. Réessayez dans un
            instant.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              width: "100%",
              padding: "14px 24px",
              border: "none",
              borderRadius: 9999,
              background: "#E8C547",
              color: "#1A1A1A",
              fontSize: 13,
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.05em",
              cursor: "pointer",
            }}
          >
            Réessayer
          </button>
        </div>
      </body>
    </html>
  );
}
